import BannerStrategy from "./banner";
import CategoryNavigationStrategy from "./category-navigation";
import DealerFeatureBlockStrategy from "./dealer-feature-block";
import DividerStrategy from "./divider";
import FeaturedCollectionsStrategy from "./featured-collections";
import FeaturedProductCollectionsStrategy from "./featured-product-collections";
import ImageBlockStrategy from "./image-block";
import ImageGridStrategy from "./image-grid";
import MofoPromiseBarStrategy from "./mofo-promise-bar";
import ProductCollectionStrategy from "./product-collection";
import PushNotificationBannerStrategy from "./push-notification-banner";
import QuoteblockBlockStrategy from "./quote-block";
import RecentArticlesStrategy from "./recent-articles";
import ArticleLoaderStrategy from "./article-loader";
import RichTextBlockStrategy from "./rich-text";
import SearchHeaderStrategy from "./search-header";
import ArticleOfferStrategy from "./article-offer";
import ThreeArticlesStrategy from "./three-articles";
import ArticleSearchHeaderStrategy from "./article-search-header";
import SectionHeaderStrategy from "./section-header";
import SocialLinksStrategy from "./social-links";
import SplitBannerStrategy from "./split-banner";
import TextBlockStrategy from "./text-block";
import ThreeUpBannerGroupStrategy from "./three-up-banner-group";
import TwoUpBlockStrategy from "./two-up-block";
import VideoBlockStrategy from "./video-block";
import AccordionStrategy from "./accordion";
import UnknownStrategy from "./unknown-component";

const componentStrategies = [
  BannerStrategy,
  CategoryNavigationStrategy,
  DealerFeatureBlockStrategy,
  DividerStrategy,
  FeaturedCollectionsStrategy,
  FeaturedProductCollectionsStrategy,
  ImageBlockStrategy,
  ImageGridStrategy,
  MofoPromiseBarStrategy,
  ProductCollectionStrategy,
  QuoteblockBlockStrategy,
  RecentArticlesStrategy,
  ArticleLoaderStrategy,
  ThreeArticlesStrategy,
  RichTextBlockStrategy,
  SearchHeaderStrategy,
  ArticleSearchHeaderStrategy,
  ArticleOfferStrategy,
  SectionHeaderStrategy,
  SocialLinksStrategy,
  SplitBannerStrategy,
  TextBlockStrategy,
  ThreeUpBannerGroupStrategy,
  TwoUpBlockStrategy,
  PushNotificationBannerStrategy,
  VideoBlockStrategy,
  AccordionStrategy,
  UnknownStrategy,
];

export const ContentBlock = (data) => {
  const strategy = componentStrategies.find((strategy) => strategy.test(data));
  return strategy.create(data);
};
